import axios from "axios";
import { shouldRetryRead } from "./request-errors.js";

export const READ_TIMEOUT_MS = 15000;
export const WRITE_TIMEOUT_MS = 30000;

function waitForRetry(signal) {
  return new Promise((resolve, reject) => {
    const cancel = () => {
      clearTimeout(timer);
      reject(new axios.CanceledError());
    };
    const timer = setTimeout(() => {
      signal?.removeEventListener("abort", cancel);
      resolve();
    }, 800);
    if (signal?.aborted) cancel();
    else signal?.addEventListener("abort", cancel, { once: true });
  });
}

// Only idempotent reads may be repeated. A timed-out write may already have succeeded.
export async function getWithRetry(url, signal) {
  const options = { timeout: READ_TIMEOUT_MS, signal };
  try {
    return await axios.get(url, options);
  } catch (error) {
    if (axios.isCancel(error) || !shouldRetryRead(error, navigator.onLine)) throw error;
    await waitForRetry(signal);
    return axios.get(url, options);
  }
}
